import React from 'react';
import Icon from '../../../components/AppIcon';

const SuccessHeader = ({ referenceNumber, onCopyReference }) => {
  return (
    <div className="text-center mb-8">
      {/* Success Icon */}
      <div className="flex justify-center mb-6">
        <div className="w-20 h-20 bg-success rounded-full flex items-center justify-center shadow-elevation-3 animate-pulse">
          <Icon name="CheckCircle" size={40} color="white" strokeWidth={2.5} />
        </div>
      </div>

      {/* Success Message */}
      <h1 className="text-2xl md:text-3xl font-bold text-text-primary mb-4 font-inter">
        Vérification soumise avec succès !
      </h1>
      
      <p className="text-text-secondary text-base md:text-lg mb-6 font-inter max-w-2xl mx-auto">
          Notre service va vous contacter sur la plage horaire que vous nos avez séléctionnée.<br/>
          Vous recevrez une notification par email une fois le processus terminé.
      </p>

    </div>
  );
};

export default SuccessHeader;